export const backgrounds = {
  primary: {
    default: "#007bff",
    success: "#28a745",
    danger: "#dc3545",
    warning: "#ffc107",
    dark: "#333",
    light: "#f7f7f7"
  },
  secondary: {
    default: "transparent",
    success: "transparent",
    danger: "transparent",
    warning: "transparent",
    dark: "transparent",
    light: "transparent"
  },
  tertiary: {
    default: "transparent",
    success: "transparent",
    danger: "transparent",
    warning: "transparent",
    dark: "transparent",
    light: "transparent"
  },
  light: {
    default: "#cce5ff",
    success: "#d4edda",
    danger: "#f8d7da",
    warning: "#fff3cd",
    dark: "#d6d8d9",
    light: "#f7f7f7"
  }
};

export const colors = {
  primary: {
    default: "#fff",
    success: "#fff",
    danger: "#fff",
    warning: "#333",
    dark: "#fff",
    light: "#333"
  },
  secondary: {
    default: "#007bff",
    success: "#28a745",
    danger: "#dc3545",
    warning: "#ffc107",
    light: "#f7f7f7",
    dark: "#333"
  },
  tertiary: {
    default: "#333",
    success: "#333",
    danger: "#333",
    warning: "#333",
    dark: "#333",
    light: "#333"
  },
  light: {
    default: "#007bff",
    success: "#28a745",
    danger: "#dc3545",
    warning: "#ffc107",
    dark: "#333",
    light: "#333"
  }
};

export const borderColors = {
  primary: {
    default: "transparent",
    success: "transparent",
    danger: "transparent",
    warning: "transparent",
    dark: "transparent",
    light: "transparent"
  },
  secondary: {
    default: "#007bff",
    success: "#28a745",
    danger: "#dc3545",
    warning: "#ffc107",
    light: "#f7f7f7",
    dark: "#333"
  },
  tertiary: {
    default: "transparent",
    success: "transparent",
    danger: "transparent",
    warning: "transparent",
    dark: "transparent",
    light: "transparent"
  },
  light: {
    default: "transparent",
    success: "transparent",
    danger: "transparent",
    warning: "transparent",
    dark: "transparent",
    light: "transparent"
  }
};
